export default __webpack_public_path__ + "static/media/icon_bar.e29181bf.svg";